<div class="cookie-banner bg-primary p-3" *ngIf="showBanner">
  <div class="container bg-primary">
    <div class="d-flex justify-content-center align-items-center">
      <div [innerHTML]="'WEBSITE_COOKIES' | translate | safeHtml"></div>
      <button class="btn btn-info ml-2" (click)="acceptCookies()" translate>ACCEPT</button>
      <button class="btn btn-danger ml-2" (click)="declineCookies()" translate>DECLINE</button>
    </div>
  </div>
</div>
